<template>
  <b-container fluid>
    <h3>Deep Bom/Kit Info</h3>
    <b-row class="justify-content-md-center">
      <b-col class="my-2" cols=8>
        <b-form @submit="getData">
          <b-form-row class="align-items-center mb-2">
            <b-col>
              <label>Num (exact search only):</label>
            </b-col>
            <b-col>
              <input v-model="itemNum" class='form-control mb-2 ml-1 mr-2 mb-sm-0' />
            </b-col>
            <b-col>
              <b-button variant='primary' type='submit'>Search</b-button>
            </b-col>
          </b-form-row>
        </b-form>
      </b-col>
    </b-row>
    <b-row v-if="loading" class="justify-content-md-center">
      <fingerprint-spinner
        :animation-duration="1500"
        :size="300"
        color="#293a93"
        class="my-3"
      />
    </b-row>
    <b-row v-else-if="noExist" class="justify-content-md-center">
      This item doesn't seem to exist. Make sure you've typed in the exact part/product num, it may take a few minutes to show if you've just created it.
    </b-row>
    <b-row v-else-if="noneFound" class="justify-content-md-center">
      No Data Found... Does the item have a BOM or KIT that it uses?
    </b-row>
    <b-row v-else-if="item != null && item.product_id != 0">
      <b-col>
        <b-row>
          <b-col>
            <strong>Product Num:</strong>
            <router-link target="_blank" :to="{name: 'Qty Calculations', query: {productNum: item.product_num}}">
              {{item.product_num}}
            </router-link>
          </b-col>
        </b-row>
        <b-row>
          <b-col>
            <strong>Product Desc:</strong>
            {{item.product_desc}}
          </b-col>
        </b-row>
      </b-col>
    </b-row>
    <b-row v-else-if="item != null">
      <b-col>
        <b-row>
          <b-col>
            <strong>Part Num:</strong>
            <router-link target="_blank" :to="{name: 'Qty Calculations', query: {partNum: item.part_num}}">
              {{item.part_num}}
            </router-link>
          </b-col>
        </b-row>
        <b-row>
          <b-col>
            <strong>Part Desc:</strong>
            {{item.part_desc}}
          </b-col>
        </b-row>
      </b-col>
    </b-row>
    <subitem v-if="item" :key="`${item.part_id}|${item.product_id}`" :item="item" />
  </b-container>
</template>

<script>
import axios from 'axios';
import Subitem from './DeepBomInfoItem';
import { FingerprintSpinner } from 'epic-spinners';
const BASE_API = process.env.VUE_API_ROOT;

export default {
  components: {
    FingerprintSpinner,
    Subitem,
  },
  data() {
    return {
      itemNum: null,
      item: null,
      loading: false,
      noExist: false,
      noneFound: false,
    }
  },
  methods: {
    getData(event) {
      this.item = null;
      this.noExist = false;
      this.noneFound = false;
      if (event != null) event.preventDefault();
      if (this.itemNum == null || this.itemNum.trim() === '') return;

      this.loading = true;
      axios.get(`${BASE_API}/am-old-db/part-info/deep-bom-report/${this.itemNum}`).then(response => {
        if (response.data == null) {
          this.noExist = true;
        } else if (Object.keys(response.data).length === 0) {
          this.noneFound = true;
          this.item = {};
        } else {
          this.item = response.data;
        }
        this.loading = false;
      }).catch(error => {
        console.error(error);
        this.loading = false;
      })
    }
  }
}
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/components/inventory/DeepBomInfo.vue